import { isEqual } from 'lodash';

import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type SingleValueFilter } from '../types/filters';

export type CustomSkillTaxonomySelection = {
  taxonomyId?: number;
  version?: string;
};

export const skillTaxonomyDefinition: FilterDefinition<
  SingleValueFilter<CustomSkillTaxonomySelection>
> = {
  id: FilterId.SKILL_TAXONOMY,
  name: 'Skill Taxonomy',
  value: { taxonomyId: 0 },
  type: FilterType.VALUE,
  isVisible: false,
  isActive: true,
};

export const skillTaxonomyHandler: FilterHandler<
  SingleValueFilter<CustomSkillTaxonomySelection>
> = {
  isActive(
    currentFilterState: SingleValueFilter<CustomSkillTaxonomySelection>
  ) {
    return (
      currentFilterState.value !== null &&
      currentFilterState.value !== undefined
    );
  },
  isDefault(
    currentFilterState: SingleValueFilter<CustomSkillTaxonomySelection>,
    definition: FilterDefinition<
      SingleValueFilter<CustomSkillTaxonomySelection>
    >
  ) {
    return isEqual(currentFilterState.value, definition.value);
  },
  getEffectiveFilter(
    currentFilterState: SingleValueFilter<CustomSkillTaxonomySelection>
  ) {
    return { ...currentFilterState };
  },
};
